module.exports = __webpack_public_path__ + "static/02-15f182fde0022241485ee35fe8ff8c7a.jpg";